import fetch from 'isomorphic-fetch';

export const API_URL = process.env.REACT_APP_VENUE_API_URL || 'https://prod-api.vmnk.in/venue-service';

export default function venueCallApi(
    endpoint,
    method = 'get',
    body,
    { headerVal = false, noApi = false, version = 'v1' } ={}
) {
    let token = typeof window === 'undefined' ? '' : window.localStorage.getItem('idToken');
    let headers = {};
    headers['content-type'] = `${headerVal ? headerVal : 'application/json'}`;
    if (token && token !== '') {
        headers.Authorization = `Bearer ${token}`;
    }
    const FINAL_URL = `${API_URL}/${noApi === false ? `${version}/` : ''}${endpoint}`;
    return fetch(FINAL_URL, {
        headers: headers,
        method,
        body: JSON.stringify(body),
        referrer: '',
        referrerPolicy: 'origin-when-cross-origin',
    })
        .then((response) => response.json().then((json) => ({ json, response })))
        .then(({ json, response }) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            (response) => response,
            (error) => error
        );
}

export function venueCallApiFormData(endpoint, method = 'get', formData, headerVal, noApi = false) {
    let token = typeof window === 'undefined' ? '' : window.localStorage.getItem('idToken');
    let headers = {};
    headers['content-type'] = 'multipart/form-data;';
    headers['Accept'] = 'application/json, application/xml, text/plain, text/html, *.*';
    if (token && token !== '') {
        headers.Authorization = `Bearer ${token}`;
    }
    const FINAL_URL = `${API_URL}/${endpoint}`;
    return fetch(FINAL_URL, {
        headers: headers,
        method,
        body: formData,
        referrer: '',
        referrerPolicy: 'origin-when-cross-origin',
    })
        .then((response) => response.json().then((json) => ({ json, response })))
        .then(({ json, response }) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            (response) => response,
            (error) => error
        );
}

export function uploadFile(endpoint, method = 'get', body) {
    const token = window.localStorage.getItem('token') ? window.localStorage.getItem('token') : '';
    const headers = {};
    if (token && token !== '') {
        headers.Authorization = `Bearer ${token}`;
    }
    return fetch(`${API_URL}/${endpoint}`, {
        headers,
        method,
        body,
    })
        .then((response) => response.json().then((json) => ({ json, response })))
        .then(({ json, response }) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            (response) => response,
            (error) => error
        );
}
